<template>
    <button :class="saveButtonClass"
            :disabled="loading || success">
        <fa v-if="success" class="fa-fw fa-thumbs-up"></fa>
        <fa v-else :class="'fa-spin fa-fw fa-circle-notch' + loadingClass"></fa>
        {{ success ? 'Saved!' : label }}
        <fa class="fa-fw invisible"></fa>
    </button>
</template>
<script>
    export default {
        props: ['label', 'loading', 'success'],
        data: function () {
            return {};
        },
        computed: {
            loadingClass() {
                return this.loading ? '' : ' invisible';
            },
            saveButtonClass() {
                return this.success ? 'btn btn-success opacity-100' : 'btn btn-primary';
            }
        },
        methods: {
        },
    };
</script>
